import {ErrorMessage, Field, Form, Formik} from "formik";
import postData from "../services/postData";
import Modal from "./Modal";
import {useState, useEffect} from "react";
import {ScrollToFieldError} from "./formik/ScrollToFieldError";
import {formSchema} from "../schema/formSchema";
import SkodaSecondDataInfo from "./SkodaSecondDataInfo";
import SkodaDataInfo from "./SkodaDataInfo";

export default function ServiceForm({setLoadingSpinnerOpen}) {

    const formType = 'newsletter,nowy,superb,2024';

    const [successModal, setSuccessModal] = useState(false);
    const [failureModal, setFailureModal] = useState(false);
    const [formIsSubmitting, setFormIsSubmitting] = useState(false);

    useEffect(() => {
        if (window.Sentry) {
            window.Sentry.init();
        }
    }, []);
    

    const dataLayerPush = (orderId) => {
        try {
            window.dataLayer.push({
                'event': 'formularze',
                'wypelniony-formularz': 'newsletter-zamowiono',
                'orderid': orderId
            });
            console.log('dataLayer.push ok:', orderId);
        } catch (err) {
            console.error('dataLayer.push error:', err);
        }
    };

    const syneriseSendFormData = (orderId, values) => {
        if (!('SR' in window)) {
            console.error('SR undefined');
            return;
        }

        const snrData = {
            orderID: orderId,
            firstname: values.firstName, //imie
            email: values.email, //email
            newsletterAgreement: values.newsletterAgreement ? 'enabled' : 'disabled',
            newsletter_info: values.newsletter_info,
            statute: values.statute,
        };
        try {
            window.SR.event.sendFormData(formType, snrData)
                .then((res) => {
                    console.log(formType);
                    console.log(res);
                })
                .catch((err) => {
                    console.log(formType);
                    console.error(err);
                });
        } catch (err) {
            console.error('SR error', err);
        }
    };
    
    const insertSyneriseScript = () => {
        const syneriseScript = document.createElement('script');
        syneriseScript.innerHTML = `
            function onSyneriseLoad() {
                SR.init({
                    'trackerKey':'F79A2C6D-7D1D-2E3A-F1D4-997A40970066',
                });
            }

            (function(s,y,n,e,r,i,se){s['SyneriseObjectNamespace']=r;s[r]=s[r]||[],s[r]._t=1*new Date(),
                s[r]._i=0,s[r]._l=i;var z=y.createElement(n),se=y.getElementsByTagName(n)[0];z.async=1;z.src=e;
                se.parentNode.insertBefore(z,se);z.onload=z.onreadystatechange=function(){var rdy=z.readyState;
                    if(!rdy||/complete|loaded/.test(z.readyState)){s[i]();z.onload = null;z.onreadystatechange=null;}};
            })(window,document,'script','//www.snrcdn.net/sdk/3.0/synerise-javascript-sdk.min.js','SR', 'onSyneriseLoad');
        `;
        document.body.appendChild(syneriseScript);
    }

    return (
        <Formik
            initialValues={{
                firstName: '',
                email: '',
                newsletterAgreement: false,
                newsletter_info: false,
                statute: false,
            }}
            validationSchema={formSchema}
            onSubmit={(values, actions) => {
                actions.setSubmitting(false);
                setFormIsSubmitting(true);
                
                if(window.SR === undefined) {
                    insertSyneriseScript();
                }

                const intervalId = setInterval(() => {
                    if ((window.SR !== undefined)) {
                        clearInterval(intervalId);

                        values['formType'] = formType;
        
                        postData(values)
                            .then((data) => {
                                if (data && data.status === 'ok') {
        
                                    dataLayerPush(data.orderId);
                                    syneriseSendFormData(data.orderId, values);
                                    actions.resetForm();
                                    setSuccessModal(true);
                                } else {
                                    setFailureModal(true);
                                    // Report to Sentry
                                    window?.Sentry?.captureException(new Error('WLS error'));
                                }
                            })
                            .catch((error) => {
                                setFailureModal(true);
                                // Report to Sentry
                                window?.Sentry?.captureException(error);
                            })
                            .finally(() => {
                                setFormIsSubmitting(false);
                                // setLoadingSpinnerOpen(false);
                                window.scrollTo({
                                    top: 0,
                                    left: 0,
                                    behavior: "smooth"
                                });
                            });
                    }
                }, 300);

                // Set failure when no SR in window after 5s
                setTimeout(() => {
                    clearInterval(intervalId);
                    if (window.SR === undefined) {
                        setFailureModal(true);                    
                        setFormIsSubmitting(false);
                        window.scrollTo({
                            top: 0,
                            left: 0,
                            behavior: "smooth"
                        });
                        return;
                    }
                }, 5000);
            }}
        >
            {(formikProps) => (
                <>
                    <Modal open={successModal} setOpen={setSuccessModal}>
                        <b>Dziękujemy za wybór Škody</b>
                    </Modal>

                    <Modal open={failureModal} setOpen={setFailureModal}>
                        Wystąpił błąd!<br/>
                        Prosimy spróbować później.
                    </Modal>

                    <Form className="form-container form-container js-subscribe-form" method={`post`}>
                        <ScrollToFieldError/>


                        <div className="form-row">
                            <div className="form-copy">
                                <b><h2>Wejdź do świata Škody!</h2></b>
                                <p>
                                    Dowiedz się więcej i szybciej niż inni! Zyskaj wczesny dostęp do nowości, premier nowych modeli, najlepszych ofert i innych ważnych informacji.
                                </p>
                            </div>
                        </div>

                        <div className="form-row">
                            <label className="form-label" htmlFor="firstName">Imię</label>
                            <Field id="firstName" name="firstName" type="text" className="form-input" maxLength={50}></Field>
                            <ErrorMessage name="firstName">{msg => <div className="form-error">{msg}</div>}</ErrorMessage>
                        </div>

                        <div className="form-row">
                            <label className="form-label" htmlFor="email">Adres - email*</label>
                            <Field id="email" name="email" type="email" className="form-input" maxLength={255}></Field>
                            <ErrorMessage name="email">{msg => <div className="form-error">{msg}</div>}</ErrorMessage>
                        </div>
                        {/*<div style={{paddingBottom: "10px"}}>&nbsp;</div>*/}
                        <br/>
                        <div className="form-row">
                            <div className="form-checkbox">
                                <Field className="form-check-input" id="newsletterAgreement" name="newsletterAgreement" type="checkbox"></Field>
                                <label htmlFor="newsletterAgreement" className="form-check-label">
                                    Chcę otrzymywać Newsletter od Volkswagen Group Polska Sp. z o.o. z wykorzystaniem adresu e-mail oraz pozostałych podanych przeze mnie Danych.                               </label>
                            </div>
                            <ErrorMessage name="newsletterAgreement">{msg => <div className="form-error">{msg}</div>}</ErrorMessage>
                        </div>
                        <div className="form-row">
                            <div className="form-checkbox">
                                <Field className="form-check-input" id="newsletter_info" name="newsletter_info" type="checkbox"></Field>
                                <label htmlFor="newsletter_info" className="form-check-label">
                                    W ramach Newslettera zgadzam się na otrzymywanie od Volkswagen Group Polska Sp. z o.o. w/w informacji mogących stanowić informacje handlowe i marketingowe.                           </label>
                            </div>
                            <ErrorMessage name="newsletter_info">{msg => <div className="form-error">{msg}</div>}</ErrorMessage>
                        </div>
                        <div className="form-row">
                            <div className="form-checkbox">
                                <Field className="form-check-input" id="statute" name="statute" type="checkbox"></Field>
                                <label htmlFor="statute" className="form-check-label">
                                    Akceptuję <a
                                    href="https://twoja.skoda.pl/brandportal/newsletter/rules/0afc6cb8156bd43640a6a5f47d5f655f4c45c2b1.pdf"
                                    target="_blank">regulamin</a>
                                </label>
                            </div>
                            <ErrorMessage name="statute">{msg => <div className="form-error">{msg}</div>}</ErrorMessage>
                        </div>
                        <SkodaSecondDataInfo/>
                        <SkodaDataInfo/>
                        <br/>
                        <div className="form-row form-row--buttons">
                            <button type="submit" className="button button--primary"
                                    disabled={formIsSubmitting}>Zapisz
                            </button>
                            <br/> <br/>
                            <br/> <br/>
                        </div>
                    </Form>
                </>
            )}
        </Formik>
    );
}
